import axios from "axios";

export const fetchPictogram = async (pictogramId, params) => {
  try {
    const { data } = await axios.get(
      "/api/v2/pictogram/" + pictogramId,
      { params: params }
    );

    if (data && data.success) {
      return data.pictogram;
    }
    // throw new Error("No se pudo obtener la lista de pictogramas.");
    return null;
  } catch (e) {
    let error = null;

    if (axios.isAxiosError(e)) {
      // console.error("Error de red al cargar configuración del proyecto", e.message);
      error = new Error("Fallo en la solicitud HTTP para pictograma del proyecto.");
    } else {
      console.error("Error inesperado al cargar pictograms del proyecto", e);
      error = new Error("No se pudo cargar la pictograms del proyecto.");
    }

    error.original = e;
    throw e;
  }

}

export const fetchPictograms = async (projectId, params) => {
  try {
    const { data } = await axios.get(
      "/api/v2/project/" + projectId + "/pictograms",
      { params: params }
    );

    if (data && data.success) {
      return data.pictograms;
    }
    // throw new Error("No se pudo obtener la lista de pictogramas.");
    return null;
  } catch (e) {
    let error = null;

    if (axios.isAxiosError(e)) {
      // console.error("Error de red al cargar configuración del proyecto", e.message);
      error = new Error("Fallo en la solicitud HTTP para pictograma del proyecto.");
    } else {
      console.error("Error inesperado al cargar pictograms del proyecto", e);
      error = new Error("No se pudo cargar la pictograms del proyecto.");
    }

    error.original = e;
    throw e;
  }

}

export function assignStatusesToLayers(data) {
  return axios.post('/api/v2/pictograms/assign-statuses', data);
}

export function saveDataLayers(payload) {
  return axios.post('/api/v2/pictogram/'+payload.pictogram_id+'/update-layers', payload);
}

export function saveStatusesLayers(payload) {
  return axios.post('/api/v2/pictogram/'+payload.pictogram_id+'/statuses', payload);
}

export function getLinkedEntities(pictogramId, params = {}) {
  return axios.get('/api/v2/pictogram/' + pictogramId + '/linked-entities', params);
}

export function unlinkEntities(pictogramId, payload) {
  return axios.post('/api/v2/pictogram/' + pictogramId + '/unlink', payload);
}

export function assignEntities(payload) {
  return axios.post('/api/v2/pictogram/assign', payload);
}

export function recalculateProgress(pictogramId) {
  return axios.post('/api/v2/pictogram/' + pictogramId + '/recalculate-progress');
}

export function getPictogramDesign(pictogramId) {
  return axios.get('/api/v2/pictogram/' + pictogramId + '/design');
}

// Info de un elemento eléctrico/zanjas por handle (popover del visor):
// extra_attributes (o boqLink de la capa), progreso y certificación por metros.
export function getElectricalComponentInfo(pictogramId, handle, workLyr) {
  return axios.get('/api/v2/pictogram/' + pictogramId + '/component-info', {
    params: { handle, work_lyr: workLyr },
  });
}

export function updatePictogramDesignGeoreferencing(pictogramId, payload) {
  return axios.patch('/api/v2/pictogram/' + pictogramId + '/design', payload);
}

export function editPartialPictogram(pictogramId, payload) {
  return axios.patch('/api/v2/pictogram/' + pictogramId, payload);
}

export function previewVersionUpload(pictogramId, payload) {
  return axios.post('/api/v2/pictogram/' + pictogramId + '/upload-version/preview', payload);
}

export function confirmVersionUpload(pictogramId, payload) {
  return axios.post('/api/v2/pictogram/' + pictogramId + '/upload-version/confirm', payload);
}

export function getPendingVersion(pictogramId) {
  return axios.get('/api/v2/pictogram/' + pictogramId + '/pending-version');
}

export function discardPendingVersion(pictogramId) {
  return axios.delete('/api/v2/pictogram/' + pictogramId + '/pending-version');
}

export function getPendingVersionSceneUrl(pictogramId) {
  return axios.get('/api/v2/pictogram/' + pictogramId + '/pending-version/scene-url');
}

export function getPendingVersionDxfUrl(pictogramId) {
  return axios.get('/api/v2/pictogram/' + pictogramId + '/pending-version/dxf-url');
}

export function getCurrentDxfUrl(pictogramId) {
  return axios.get('/api/v2/pictogram/' + pictogramId + '/dxf-url');
}

export function getCurrentSceneBinaryUrl(pictogramId) {
  return axios.get('/api/v2/pictogram/' + pictogramId + '/scene-binary-url');
}

/**
 * Registra un tramo de avance lineal sobre una polilínea de electrical/trench.
 * Cuerpo: { dxf_handle, total_length, direction, executed_quantity,
 *           status_id?, start_date }
 */
export function registerLayerProgress(pictogramId, layerId, payload) {
  return axios.post(
    '/api/v2/pictogram/' + pictogramId + '/layer/' + layerId + '/progress',
    payload
  );
}

/**
 * Hidratación del LayoutBuilder en electrical/trenches: devuelve los Component
 * Mongo del pictograma (uno por polyline) + diccionario de statuses indexados
 * por id (para resolver label/color sin guardar caches en los segments).
 */
export function getPictogramComponents(pictogramId) {
  return axios.get('/api/v2/pictogram/' + pictogramId + '/components');
}

export function startRestoreFromVersion(pictogramId, fromDocumentVersionId) {
  return axios.post('/api/v2/pictogram/' + pictogramId + '/restore-version/' + fromDocumentVersionId);
}

export function deleteDocumentVersion(pictogramId, documentVersionId) {
  return axios.delete('/api/v2/pictogram/' + pictogramId + '/version/' + documentVersionId);
}

/**
 * Acciones masivas: replicar configuración/grupos/estados de una capa source
 * a múltiples capas target del mismo pictograma.
 *
 * payload: {
 *   source_layer_id, target_layer_ids: [],
 *   options: { apply_form_config, apply_groups, apply_statuses, apply_incidents }
 * }
 */
export function bulkApplyLayerConfig(pictogramId, payload) {
  return axios.post(
    '/api/v2/pictogram/' + pictogramId + '/layers/bulk-apply-config',
    payload
  );
}
